// You can use CONSTANTS.js file for below definitions of constants and import here.
import callApi from "../../Api";
import { mapValues , groupBy,compact } from "lodash";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";

export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS";


export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

export const fetchDetails = (reqObj) => async (dispatch) => {
  dispatch(openLoader())
  const data = await callApi.get(`dashboard/details`,{params:reqObj});
  if (data && data.data.success) {
    const dashboardData = { ...data.data.data}
    const monthNumber = new Date().getMonth() +1;
    const labels = [];
    const classGroupNames = dashboardData.classGroupData.map(obj=> obj.name);
    const labelNames = {};
    const studentCountByYearLabelNames = {};
    classGroupNames.forEach(obj=>{
      labelNames[`${obj}`] = []
      studentCountByYearLabelNames[`${obj}`] = []
    });
    [...Array(monthNumber).keys()].forEach((monthObj,monthIndex)=>{
      const month = monthObj + 1;
      const monthWiseData = dashboardData.monthWiseStudentsData.filter(monthWiseObj=>{
        return parseInt(monthWiseObj.monthName) === month;
      })
      console.log(monthWiseData)
      if(monthWiseData.length > 0 ){
        console.log("New Index",month)
        classGroupNames.forEach(classGroupObj=>{
          console.log(monthWiseData.map(obj=> obj.name),classGroupObj)
          if( monthWiseData.map(obj=> obj.name).includes(classGroupObj) ){
            monthWiseData.forEach(monthObj=>{
              console.log(monthObj)
              if(classGroupObj === monthObj.name ){
                labelNames[`${monthObj.name}`].push(parseInt(monthObj.totalStudents))
              }
            })
          }else{
            labelNames[`${classGroupObj}`].push(0)
          }
          
        })
          
      }else{
        console.log("else Index",month)
        classGroupNames.forEach(classGroupObj=>{
          labelNames[`${classGroupObj}`].push(0)
        });
      }
      labels.push(`${month}/01/${reqObj.year}`)
    })
    const studentSeriesData = []
    console.log(labelNames)
    const chartType = ['column','area','line','column']
     Object.keys(labelNames).forEach((obj,index)=>{
           studentSeriesData.push({
            name: obj,
            type: chartType[`${index}`],
            data: labelNames[`${obj}`]
        });
     });

     console.log(studentSeriesData)
    dashboardData.studentSeriesData = {
      data : studentSeriesData,
      labels
    };
    const yearLevelData = mapValues(groupBy(dashboardData.yearWiseStudentData, 'studentYear'));
    const studentYearLabels = Object.keys(yearLevelData).filter(obj=> obj !== 'null');
    // {
    //   name: "Play Group",
    //   data: [44, 55, 41, 37, 22, 43, 21],
    // },
    console.log(classGroupNames,yearLevelData)
    studentYearLabels.forEach(obj=>{
      if(obj !== 'null'){
        yearLevelData[`${obj}`].forEach(group=>{
          const namesList = yearLevelData[`${obj}`].map(nameObj=> nameObj.name);
          console.log(namesList)
          // classGroupNames.forEach(classGroup=>{
          //   console.log(classGroup,group,namesList.includes(classGroup))
          //   if(namesList.includes(classGroup)){
              studentCountByYearLabelNames[`${group.name}`].push(parseInt(group.totalStudents))
            // }else{
            //   studentCountByYearLabelNames[`${classGroup}`].push(parseInt(0))
            // }
          // })
          
        })
      }
    })
    console.log(yearLevelData,studentYearLabels,studentCountByYearLabelNames)
    dashboardData.studentCountYearLevel = {
      data : studentCountByYearLabelNames,
      years:studentYearLabels
    };
    // dashboardData.nursery = dashboardData.filter(obj=> obj.name === 'Nursery')
    dispatch({ type: GET_DASHBOARD_DETAILS, payload: dashboardData });
    // ToastMessage(SUCCESS,data.messages.success);
    dispatch(closeLoader())
  }else{
    dispatch(closeLoader())
    // ToastMessage(ERROR,data.data.message);
  }
};
